// extracted by mini-css-extract-plugin
export default {"title":"RL3nq","buttonWrapper":"GvBNP","button":"dIwXi","collapse":"JiaCW","isOpen":"vVsXW"};